// @ts-nocheck
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Pages/RequestRma/Handlers/SendRmaRequest";
import { addToChainAfter, createChainHandler } from "@toolkit/Modules/client-framework/HandlerCreator";

export const PopulateAdditionalApiParameter = createChainHandler("PopulateAdditionalApiParameter", chain, props => {
    const state = props.getState();
    if (state.store.pages.requestRma.warehouse) {
        props.apiParameter.rmaModel.notes = `${props.apiParameter.rmaModel.notes} <br/><br/>Return Warehouse: ${state.store.pages.requestRma.warehouse}`;
    }
    props.apiParameter.rmaModel.notes = `${props.apiParameter.rmaModel.notes} <br/><br/>ERP Order Number: ${props.parameter.orderNumber}`;
});

addToChainAfter(chain, PopulateApiParameter, PopulateAdditionalApiParameter);
